module.exports = __webpack_public_path__ + "static/25-1b18d7902983fc66743ef0fe5a819772.gif";